/* Azahara Ferrer · Carrito nativo (cajón + página) */
(() => {
  if (window.AFCart) return;
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const sections = () => [...document.querySelectorAll('[data-afc-section]')];
  const ids = () => [...new Set(sections().map((el) => el.dataset.afcSection))];
  const drawer = () => document.querySelector('[data-afc-drawer]');
  let internal = false;

  const apply = (map) => {
    Object.entries(map || {}).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(`[data-afc-section="${id}"] [data-afc-content]`);
      document.querySelectorAll(`[data-afc-section="${id}"] [data-afc-content]`).forEach((el) => { if (fresh) el.innerHTML = fresh.innerHTML; });
    });
    init();
  };
  const bubble = (count) => {
    document.querySelectorAll('cart-icon').forEach((c) => c.renderCartBubble?.(count));
    document.querySelectorAll('[data-afc-count]').forEach((el) => { el.textContent = count; });
  };
  const busy = (on) => sections().forEach((s) => s.classList.toggle('is-busy', on));

  async function refresh() {
    const list = ids(); if (!list.length) return;
    const res = await fetch(`${ROOT}?sections=${list.join(',')}`);
    apply(await res.json());
    const cart = await (await fetch(`${ROOT}cart.js`)).json();
    bubble(cart.item_count);
  }
  async function change(key, quantity) {
    busy(true);
    try {
      const res = await fetch(`${ROOT}cart/change.js`, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity, sections: ids() }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message);
      apply(data.sections); bubble(data.item_count);
    } catch (e) { alert(e.message || 'No se pudo actualizar el carrito'); } finally { busy(false); }
  }
  async function add(items, { open = true } = {}) {
    internal = true;
    try {
      const res = await fetch(`${ROOT}cart/add.js`, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items, sections: ids() }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo añadir al carrito');
      if (data.sections) apply(data.sections); else await refresh();
      const cart = await (await fetch(`${ROOT}cart.js`)).json();
      bubble(cart.item_count);
      if (open) openDrawer();
      return data;
    } finally { internal = false; }
  }

  let lastFocus = null;
  function openDrawer() {
    const d = drawer(); if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    d.querySelector('[data-afc-close]')?.focus();
    startTimers();
    return true;
  }
  function closeDrawer() {
    const d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus?.focus?.();
  }

  /* Moneda */
  const money = (cents) => {
    const fmtEl = document.querySelector('[data-afc-money]');
    const format = (fmtEl && fmtEl.dataset.afcMoney) || '${{amount}}';
    const fmt = (n, d, ts = ',', ds = '.') => { const [i, f] = (n / 100).toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : ''); };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({ amount: fmt(cents, 2), amount_no_decimals: fmt(cents, 0), amount_with_comma_separator: fmt(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ',') })[k] ?? fmt(cents, 2));
  };
  const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* Recomendaciones automáticas (motor de Shopify) según lo que hay en el carrito */
  const recCache = new Map();
  const shuffle = (a) => { for (let i = a.length - 1; i > 0; i--) { const k = Math.floor(Math.random() * (i + 1)); [a[i], a[k]] = [a[k], a[i]]; } return a; };
  const imgUrl = (src, w) => { if (!src) return ''; let u = typeof src === 'string' ? src : src.src || src.url || ''; if (u.startsWith('//')) u = 'https:' + u; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
  function card(p, label) {
    const variants = p.variants || [];
    const v = variants.find((x) => x.available) || variants[0];
    const names = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    const single = variants.length === 1 && (variants[0].title === 'Default Title' || names[0] === 'Title');
    const selects = single ? '' : names.map((n, i) => {
      const vals = [...new Set(variants.map((x) => x.options[i]))];
      return `<select aria-label="${esc(n)}" data-afc-up-opt>${vals.map((val) => `<option value="${esc(val)}" ${val === v.options[i] ? 'selected' : ''}>${esc(val)}</option>`).join('')}</select>`;
    }).join('');
    const json = JSON.stringify(variants.map((x) => ({ id: x.id, options: x.options, available: x.available, price: x.price, compare_at_price: x.compare_at_price }))).replace(/</g, '\\u003c');
    const title = String(p.title).split(' | ')[0];
    return `<div class="afc-up" data-afc-up><script type="application/json">${json}<\/script>
      <a class="afc-up__img" href="${esc(p.url)}"><img src="${esc(imgUrl(p.featured_image, 220))}" alt="${esc(p.title)}" loading="lazy" width="90" height="90"></a>
      <div class="afc-up__body"><a class="afc-up__title" href="${esc(p.url)}">${esc(title)}</a>
      <div class="afc-up__row">${selects}<button type="button" class="afc-up__add" data-afc-up-add data-id="${v.id}">${esc(label)}</button></div>
      <div class="afc-up__prices"><s data-afc-up-was ${v.compare_at_price > v.price ? '' : 'hidden'}>${money(v.compare_at_price || 0)}</s><strong data-afc-up-price>${money(v.price)}</strong></div></div></div>`;
  }
  async function fillAuto(box) {
    const ids = (box.dataset.productIds || '').split(',').filter(Boolean);
    if (!ids.length) return;
    const key = ids.join(',');
    let picks = recCache.get(key);
    if (!picks) {
      const inCart = new Set(ids.map(Number));
      const lists = await Promise.all(ids.slice(0, 4).map((id) =>
        fetch(`${ROOT}recommendations/products.json?product_id=${id}&limit=10&intent=related`).then((r) => (r.ok ? r.json() : { products: [] })).catch(() => ({ products: [] }))));
      const seen = new Set(); picks = [];
      lists.forEach((l) => (l.products || []).forEach((p) => {
        if (!p.available || inCart.has(p.id) || seen.has(p.id)) return;
        seen.add(p.id); picks.push(p);
      }));
      picks = shuffle(picks).slice(0, +box.dataset.limit || 6);
      recCache.set(key, picks);
    }
    if (!picks.length) return;
    box.querySelector('[data-afc-up-track]').innerHTML = picks.map((p) => card(p, box.dataset.button)).join('');
    box.hidden = false;
    init();
  }

  let tick;
  function startTimers() {
    clearInterval(tick);
    const els = [...document.querySelectorAll('[data-afc-timer]')]; if (!els.length) return;
    const mins = +els[0].dataset.minutes || 5;
    let end = +sessionStorage.getItem('afc-timer-end') || 0;
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; sessionStorage.setItem('afc-timer-end', end); }
    const draw = () => {
      const left = Math.max(0, end - Date.now());
      const m = String(Math.floor(left / 60000)).padStart(2, '0'), s = String(Math.floor(left / 1000) % 60).padStart(2, '0');
      els.forEach((el) => { el.textContent = left > 0 ? el.dataset.text.replace('[time]', `${m}:${s}`) : el.dataset.expired; });
      if (left <= 0) clearInterval(tick);
    };
    draw(); tick = setInterval(draw, 1000);
  }

  function init() {
    /* Con carrito lateral activo, "Añadir al carrito" nunca redirige a /cart: abre el lateral */
    if (drawer()) document.querySelectorAll('[data-af-atc][data-after-add="cart"]').forEach((b) => { b.dataset.afterAdd = 'stay'; });
    document.querySelectorAll('[data-afc-qty]:not([data-ready])').forEach((b) => {
      b.dataset.ready = '1';
      b.addEventListener('click', () => change(b.dataset.key, +b.dataset.afcQty));
    });
    document.querySelectorAll('[data-afc-up]:not([data-ready])').forEach((card) => {
      card.dataset.ready = '1';
      const variants = JSON.parse(card.querySelector('script[type="application/json"]').textContent);
      const btn = card.querySelector('[data-afc-up-add]');
      const selects = [...card.querySelectorAll('[data-afc-up-opt]')];
      const sync = () => {
        const v = variants.find((x) => x.options.every((o, i) => !selects[i] || o === selects[i].value));
        btn.disabled = !v || !v.available;
        if (v) {
          btn.dataset.id = v.id;
          const pr = card.querySelector('[data-afc-up-price]'), was = card.querySelector('[data-afc-up-was]');
          if (pr) pr.textContent = money(v.price);
          if (was) { was.hidden = !(v.compare_at_price > v.price); was.textContent = money(v.compare_at_price || 0); }
        }
      };
      selects.forEach((s) => s.addEventListener('change', sync));
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        try { await add([{ id: +btn.dataset.id, quantity: 1 }], { open: false }); } catch (e) { alert(e.message); btn.disabled = false; }
      });
    });
    document.querySelectorAll('[data-afc-auto]:not([data-auto-ready])').forEach((box) => { box.dataset.autoReady = '1'; fillAuto(box); });
    document.querySelectorAll('[data-afc-upsell]:not([data-ready])').forEach((u) => {
      u.dataset.ready = '1';
      const t = u.querySelector('[data-afc-up-track]');
      const step = (dir) => t.scrollBy({ left: dir * (t.children[0]?.offsetWidth || 300), behavior: 'smooth' });
      u.querySelector('[data-afc-up-prev]')?.addEventListener('click', () => step(-1));
      u.querySelector('[data-afc-up-next]')?.addEventListener('click', () => step(1));
    });
    document.querySelectorAll('[data-afc-note]:not([data-ready])').forEach((n) => {
      n.dataset.ready = '1';
      n.addEventListener('change', () => fetch(`${ROOT}cart/update.js`, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ note: n.value }) }));
    });
    if (document.querySelector('[data-afc-timer]') && (drawer()?.classList.contains('is-open') || document.querySelector('.afc-page [data-afc-timer]'))) startTimers();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-afc-close], [data-afc-overlay]')) { closeDrawer(); return; }
    const a = e.target.closest('a[href]');
    if (!a || !drawer()) return;
    const url = new URL(a.href, location.href);
    const isCart = url.origin === location.origin && url.pathname.replace(/\/$/, '') === `${ROOT}cart`.replace(/\/$/, '');
    if (isCart && !a.closest('[data-afc-drawer], .afc-page') && !location.pathname.startsWith(`${ROOT}cart`)) {
      e.preventDefault(); openDrawer();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer()?.classList.contains('is-open')) closeDrawer(); });

  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await nativeFetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (!internal && res.ok && /\/cart\/add(\.js)?(\?|$)/.test(url) && drawer()) {
        internal = true;
        refresh().then(openDrawer).finally(() => { internal = false; });
      }
    } catch (e) {}
    return res;
  };

  /* Shopify (acciones estándar) pide "abrir carrito" tras añadir; el tema lo mandaba a /cart. Lo redirigimos al lateral. */
  const claimOpenCart = () => {
    const actions = window.Shopify && window.Shopify.actions;
    if (!drawer() || !actions || !actions.openCart || !actions.openCart.configure) return;
    actions.openCart.configure({ async handler() { try { await refresh(); } catch (e) {} openDrawer(); } });
  };
  document.addEventListener('DOMContentLoaded', () => setTimeout(claimOpenCart, 0));
  window.addEventListener('load', claimOpenCart);
  claimOpenCart();

  /* Si el formulario se envió sin JavaScript (p. ej. una app retrasa los scripts), Shopify vuelve a la ficha con ?afc=open */
  const openFromUrl = () => {
    const u = new URL(location.href);
    if (u.searchParams.get('afc') !== 'open' || !drawer()) return;
    u.searchParams.delete('afc'); history.replaceState(history.state, '', u);
    refresh().catch(() => {}).finally(openDrawer);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromUrl); else openFromUrl();

  window.AFCart = { open: openDrawer, close: closeDrawer, refresh, add, change };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
